module.exports = __webpack_public_path__ + "img/play.1585c351.svg";